var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#53bd95",
    d: "M9.629,15.629c.631-.632,1.508-.952,2.392-.867l2.741-2.741c-.008-.09-.012-.18-.012-.271,0-.639,.206-1.243,.574-1.75h-2.324c-1.654,0-3-1.346-3-3V.024c-.161-.011-.322-.024-.485-.024H5C2.243,0,0,2.243,0,5v14c0,2.757,2.243,5,5,5H13.758l-4.129-4.129c-1.17-1.169-1.17-3.073,0-4.242ZM4,7h2c.552,0,1,.448,1,1s-.448,1-1,1h-2c-.552,0-1-.448-1-1s.448-1,1-1Zm0,4h7c.552,0,1,.448,1,1s-.448,1-1,1H4c-.552,0-1-.448-1-1s.448-1,1-1Zm2,6h-2c-.552,0-1-.448-1-1s.448-1,1-1h2c.552,0,1,.448,1,1s-.448,1-1,1ZM12,7V.46c.913,.346,1.753,.879,2.465,1.59l3.484,3.486c.712,.711,1.245,1.551,1.591,2.464h-6.54c-.552,0-1-.449-1-1Zm11.707,16.707c-.391,.391-1.023,.391-1.414,0l-3.957-3.957-1.586,1.586,.207,.207c.391,.391,.391,1.023,0,1.414s-1.023,.391-1.414,0l-4.5-4.5c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l.056,.056,4.586-4.586-.056-.056c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l4.5,4.5c.391,.391,.391,1.023,0,1.414s-1.023,.391-1.414,0l-.207-.207-1.586,1.586,3.957,3.957c.391,.391,.391,1.023,0,1.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalActive);
export default __webpack_public_path__ + "static/media/legal_active.61a0675ac8c2681cb6f6c6028fe722fa.svg";
export { ForwardRef as ReactComponent };